import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { REQUEST_ADDITIONAL_SEATS } from 'ui-addon-upgrades/_core/common/constants/AdminModalTypes';
import { TEAM } from 'ui-addon-upgrades/_core/common/constants/AdminTypes';
import * as tracker from 'ui-addon-upgrades/_core/common/eventTracking/tracker';
import UIAdminOnlyWrapper from 'ui-addon-upgrades/decorators/UIAdminOnlyWrapper';
import { getUpgradeDataTrackingProperties } from '../../ums/utils';
import { UPGRADE_POINT_LOCATIONS } from '../common/constants/PurchaseMotionLocations';
import { jsx as _jsx } from "react/jsx-runtime";
function PricingPageInterstitialBuySeatsButton({
  'data-selenium-id': dataSeleniumId,
  'data-test-id': dataTestId,
  seleniumId,
  onClick,
  trackingSource,
  use,
  children,
  upgradeData,
  size,
  location,
  block
}) {
  const isUpgradePoint = location && UPGRADE_POINT_LOCATIONS.includes(location);
  const {
    screen,
    upgradeProduct
  } = upgradeData;
  const handleClick = event => {
    tracker.track('interaction', {
      action: 'clicked interstitial redirect',
      screen,
      upgradeProduct
    });
    if (isUpgradePoint) {
      tracker.track('interaction', Object.assign({
        action: 'clicked upgrade point'
      }, getUpgradeDataTrackingProperties(upgradeData)));
    }
    if (onClick) {
      onClick(event);
    }
  };
  return /*#__PURE__*/_jsx(UIAdminOnlyWrapper, {
    adminType: TEAM,
    modalType: REQUEST_ADDITIONAL_SEATS,
    upgradeData: upgradeData,
    children: /*#__PURE__*/_jsx(Button, {
      "data-selenium-id": dataSeleniumId || `${trackingSource}-${seleniumId}-interstitial-add-additional-seats-button`,
      "data-test-id": dataTestId || `${trackingSource}-${seleniumId}-interstitial-add-additional-seats-button`,
      use: use,
      onClick: handleClick,
      target: "_blank",
      truncate: true,
      truncateStringProps: {
        justifyContent: 'center'
      },
      size: size,
      block: block,
      children: children || /*#__PURE__*/_jsx(FormattedMessage, {
        message: "upgrades.pricingCtas.buyAdditionalSeats"
      })
    })
  });
}
export default PricingPageInterstitialBuySeatsButton;